import { useIsVisible } from "@website/hooks/is-visible";
import { deepCompare } from "@website/utils/deep-compare";
import { numberConvert } from "@website/utils/number-convert";
import { Mapbox } from "@website/widget/mapbox";
import { ReserveMapPropertiesTypes } from "@website/widget/reserve-map/reserve-map.types";
import omit from "lodash-es/omit";
import { useRouter } from "next/router";
import { memo } from "react";

const Component = (properties: ReserveMapPropertiesTypes) => {
  const router = useRouter();
  const { title, type, showDescription = true } = properties;
  const { reference, inView } = useIsVisible();

  const isVilla = process.env.NEXT_PUBLIC_APP_NAME === "villa";
  const coords = isVilla ? properties?.circle : properties?.marker;

  if (
    !coords?.lat ||
    !coords?.lng ||
    (coords.lat === 35.696_814 && coords.lng === 51.349_818_6)
  ) {
    return null;
  }

  return (
    <div id="hotel_location">
      <div className="py-4">
        {title && (
          <h2 className="text-subtitle-1 md:text-headline-6 pb-1 md:pb-4">
            {`موقعیت های مکانی و دسترسی های ${numberConvert(title, {
              locale: router.locale
            })}`}
          </h2>
        )}
        {showDescription && (
          <div className="text-caption text-on-surface-medium-emphasis">
            {isVilla
              ? "آدرس دقیق بعد از ثبت رزرو برای شما پیامک خواهد شد."
              : `مراکز نزدیک به ${type} را میتوانید از روی نقشه مشاهده کنید.`}
          </div>
        )}
      </div>
      <div
        className="relative h-[312px] overflow-hidden bg-gray-100 md:h-[360px] xl:h-[468px] xl:rounded-2xl"
        ref={reference}
      >
        {inView ? <Mapbox {...omit(properties, ["title", "type"])} /> : false}
      </div>
    </div>
  );
};
export const ReserveMap = memo(Component, deepCompare);
